// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__2rE3o","question":"Question_question__B3pmo","description":"Question_description__y_53r"};